async function checkForUnAddedAddons() {
  const cart = JSON.parse(document.querySelector('#cart-json').innerHTML);
  const addOns = JSON.parse(localStorage.getItem('addOns'));

  console.log(addOns)
  if (!addOns) return;

  const product = cart.items.find(
    (item) => item.id == addOns.config.afinitiSelectedOption || item.properties['Reorder?'] || item.properties['Prior Order Number']
  );

  console.log(product)

  if (!product) return;

  const addOnItems = addOns.items;

  /**
   * 
   * await (await fetch('/cart/update.js',{method:"POST",headers:{ 'Content-Type':'application/json'},body:JSON.stringify({id:"43588204363974:6478bb998a2b17442b86356c659edca4",properties:{x:2}})})).json()
   * 
   */

  // Add attributes instead of the product.
  if(addOns.attributes && Object.keys(addOns.attributes).length > 0) {
    console.log("Attributes received");
    console.log({...addOns.attributes});
    const attributesObject = { ...product.properties, ...addOns.attributes};
    const response = await fetch(window.Shopify.routes.root + 'cart/change.js',{
      method:"POST",
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        id: product.key,
        properties:attributesObject
      })
    })
    console.log("RESPONSE", await response.json())
    if(response.ok) {
      console.log("response ok")
      localStorage.removeItem('addOns');

      const cartForm = document.querySelector('cart-form');
      cartForm ? cartForm.refresh() : location.reload();
    }
    return;
  }


  const itemsToBeAdded = [];


  for (const item of addOnItems) {
    const isPresentInCart = cart.items.find(
      (cartItem) =>
        cartItem.id == item.id &&
        cartItem.properties._RelatedProduct == product.key
    );
    if (isPresentInCart) continue;
    itemsToBeAdded.push({
      ...item,
      properties: { _RelatedProduct: product.key },
    });
  }
  console.log(itemsToBeAdded);

  if (itemsToBeAdded.length === 0) {
    console.log('No items to be added');
    return;
  }

  const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      items: itemsToBeAdded,
    }),
  });

  if (response.ok) {
    localStorage.removeItem('addOns');

    const cartForm = document.querySelector('cart-form');
    cartForm ? cartForm.refresh() : location.reload();
  }
}

function sendCustomCartChangeEvent() {
  const cartForm = document.querySelector('cart-form');

  if(cartForm) {
    const event = new CustomEvent('on:cart:change',{
      detail:{
        selfCreated:true
      },
      bubbles:true,
      cancelable:true
    })
    document.dispatchEvent(event)
    return
  }
  location.reload()
}

async function checkForUnAddedRushItems(onCartChange) {
  const cartResponse = await fetch(window.Shopify.routes.root + 'cart.js', 
  {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  });
  let cart = undefined;
  if(cartResponse.ok) {
    cart = await cartResponse.json();
  }

  // console.log(cartResponse)
  // console.log(cart)

  if(!cart && onCartChange) {
    sendCustomCartChangeEvent()
    return;
  }

  console.log('reached 1');
  const relevantProducts = cart.items.filter(
    (item) => item.properties._ArtifiDesignId || item.properties['Reorder?'] || item.properties['Prior Order Number']
  );
  const rushProduct = cart.items.find(
    (item) => (item.variant_id === 43059896778950)
  );

  if (!rushProduct) return;

  const rushItems = rushProduct.quantity;
  const relevantProductsLength = relevantProducts.reduce(
    (prev, curr) => prev + curr.quantity,
    0
  );

  // console.log(rushItems,relevantProductsLength)
  // console.log(rushProduct)

  let itemsAdded = false
  if (relevantProductsLength != rushItems) {
    const response = await fetch(
      window.Shopify.routes.root + `cart/change.js?id=${rushProduct.key}&quantity=${relevantProductsLength}`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
      }
    );
    if(response.ok) itemsAdded = true
  }

  if(onCartChange || itemsAdded) {
    sendCustomCartChangeEvent();
  }
}

checkForUnAddedAddons();
checkForUnAddedRushItems();
